/**
 * Auth Guard
 *
 * Redirects unauthenticated users to /auth with a returnTo param.
 * Shows loading spinner while checking session.
 */

import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useSession } from '../lib/auth-client'

interface AuthGuardProps {
	children: ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
	const { data: session, isPending, error } = useSession()
	const location = useLocation()

	if (isPending) {
		return (
			<div className="flex items-center justify-center min-h-[60vh]">
				<Loader2 size={32} className="animate-spin text-primary" />
			</div>
		)
	}

	if (error || !session?.user) {
		const returnTo = encodeURIComponent(location.pathname + location.search)
		return <Navigate to={`/auth?returnTo=${returnTo}`} replace />
	}

	return <>{children}</>
}
